import httpClient from './httpClient';

export default {
  getV2PaymentCalculatorSettings: (apiKey, externalId, scoreLetter, condition, vin, price, language, year) =>
    httpClient.get(
      `/api/v2/ecommerce/payment_calculator_settings/${apiKey}/${externalId}/${scoreLetter}/${condition}/${vin}?vehiclePrice=${price}&language=${language}&year=${year}`
    ),
  getBuildAndPricePaymentCalculatorSettings: (apiKey, externalId, scoreLetter, serializedValue, price, language) =>
    httpClient.get(
      `/api/v2/ecommerce/payment_calculator_settings/${apiKey}/${externalId}/${scoreLetter}/build_and_price?vehiclePrice=${price}&language=${language}&serializedValue=${encodeURIComponent(
        serializedValue
      )}`
    ),
};
